export const QUERY_STRING_PREFILL = 'QUERY_STRING_PREFILL'

export const queryStringPrefill = data => {
  return {
    type: QUERY_STRING_PREFILL,
    data,
  }
}
